const isValidEmailForm = (email) =>
    /^\w+([\.\-#$%&'*+=?^`{|}~_\/]*?\w*)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(email);


 export default isValidEmailForm;